import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["recommendedProductIds", "targetProductId"],
  _excluded2 = ["source", "recommendedProductIds", "targetProductId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useRef } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { SURFACE_ANALYTICS_PRODUCT_MAP } from '../../ccp-products';
import { CROSS_FLOW_CHANNEL, eventTypes } from '../../constants';
export var useFireAdControlAnalyticsEvents = function useFireAdControlAnalyticsEvents() {
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var firedViewedScreenEventName = useRef();
  var mapToCcpProductKeys = useCallback(function (recommendedProductIds, targetProductId) {
    var ccpProductIds = recommendedProductIds.reduce(function (acc, curr) {
      var _SURFACE_ANALYTICS_PR;
      acc.push((_SURFACE_ANALYTICS_PR = SURFACE_ANALYTICS_PRODUCT_MAP.products[curr]) !== null && _SURFACE_ANALYTICS_PR !== void 0 ? _SURFACE_ANALYTICS_PR : curr);
      return acc;
    }, []);
    var ccpTargetProductId = targetProductId && SURFACE_ANALYTICS_PRODUCT_MAP.products[targetProductId];
    return {
      recommendedProductIds: ccpProductIds,
      targetProductId: ccpTargetProductId !== null && ccpTargetProductId !== void 0 ? ccpTargetProductId : targetProductId
    };
  }, []);
  var fireViewedScreenEvent = useCallback(function (name, commonAttributes, attributes) {
    // Prevent duplicate events from firing
    if (firedViewedScreenEventName.current === name) {
      return;
    }
    var recommendedProductIds = commonAttributes.recommendedProductIds,
      targetProductId = commonAttributes.targetProductId,
      rest = _objectWithoutProperties(commonAttributes, _excluded);
    var _mapToCcpProductKeys = mapToCcpProductKeys(recommendedProductIds, targetProductId),
      ccpProductIds = _mapToCcpProductKeys.recommendedProductIds,
      ccpTargetProductId = _mapToCcpProductKeys.targetProductId;
    createAnalyticsEvent({
      eventType: eventTypes.SCREEN,
      name: name,
      attributes: _objectSpread(_objectSpread({
        recommendedProductIds: ccpProductIds,
        targetProductId: ccpTargetProductId
      }, rest), attributes)
    }).fire(CROSS_FLOW_CHANNEL);
    firedViewedScreenEventName.current = name;
  }, [createAnalyticsEvent, mapToCcpProductKeys]);
  var fireInteractedUIEvent = useCallback(function (event, commonAttributes, attributes) {
    var source = commonAttributes.source,
      recommendedProductIds = commonAttributes.recommendedProductIds,
      targetProductId = commonAttributes.targetProductId,
      rest = _objectWithoutProperties(commonAttributes, _excluded2);
    var _mapToCcpProductKeys2 = mapToCcpProductKeys(recommendedProductIds !== null && recommendedProductIds !== void 0 ? recommendedProductIds : [], targetProductId),
      ccpProductIds = _mapToCcpProductKeys2.recommendedProductIds,
      ccpTargetProductId = _mapToCcpProductKeys2.targetProductId;
    createAnalyticsEvent(_objectSpread(_objectSpread({
      eventType: eventTypes.UI
    }, event), {}, {
      source: source,
      attributes: _objectSpread(_objectSpread({
        recommendedProductIds: ccpProductIds,
        targetProductId: ccpTargetProductId
      }, rest), attributes)
    })).fire(CROSS_FLOW_CHANNEL);
  }, [createAnalyticsEvent, mapToCcpProductKeys]);
  return {
    fireViewedScreenEvent: fireViewedScreenEvent,
    fireInteractedUIEvent: fireInteractedUIEvent
  };
};